module.exports = __webpack_public_path__ + "media/images/binoculars-6291ced4026574498619947074a81e8d.svg";